<template>
  <Layout>
   <failed-to-fetch-modal
       v-model="failedFetchShow"
       :name="$t('purchase_orders.singular')"
       :model-id="$route.params.key"
       @back="handleBack"
       @retry="retryFailedToFetchModal"
   />
    <timeout-request-modal
        v-model="timeoutRequestModalShow"
        @back="handleBack"
        @retry="retryTimeoutRequestModal"
      />
    <Loader :loading="loading" no-axios>
      <div v-if="(model || {}).id">
        <div class="row">
          <div class="col-md-12">
            <a @click="$router.back()">
              <div class="container-title d-flex align-items-center">
                <span class="me-2">
                  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.875 15.3001L0.275 8.70008C0.175 8.60008 0.104 8.49175 0.0619998 8.37508C0.0206665 8.25842 0 8.13342 0 8.00008C0 7.86675 0.0206665 7.74175 0.0619998 7.62508C0.104 7.50842 0.175 7.40008 0.275 7.30008L6.875 0.700082C7.05833 0.516749 7.28733 0.420749 7.562 0.412083C7.83733 0.404083 8.075 0.500082 8.275 0.700082C8.475 0.883416 8.57933 1.11242 8.588 1.38708C8.596 1.66242 8.5 1.90008 8.3 2.10008L3.4 7.00008H14.575C14.8583 7.00008 15.096 7.09575 15.288 7.28708C15.4793 7.47908 15.575 7.71675 15.575 8.00008C15.575 8.28342 15.4793 8.52075 15.288 8.71208C15.096 8.90408 14.8583 9.00008 14.575 9.00008H3.4L8.3 13.9001C8.48333 14.0834 8.57933 14.3167 8.588 14.6001C8.596 14.8834 8.5 15.1167 8.3 15.3001C8.11667 15.5001 7.88333 15.6001 7.6 15.6001C7.31667 15.6001 7.075 15.5001 6.875 15.3001Z"
                        fill="#6C7589"/>
                  </svg>
                </span>
                {{ $t("purchase_orders.singular") }}
              </div>
            </a>
            <b-card v-bind="cardAttrs">

              <b-card-body>
                <div class="row">
                  <div class="col-12 mb-2 text-end" v-if="!isEditDisabled">
                    <router-link :to="`/purchase_orders/${model.id}/edit`">
                      <edit-button/>
                    </router-link>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-12" style="height: 6rem">
                            <div class="card border-0 overflow-hidden">
                              <div
                                  class="badge-container-primary d-flex justify-content-between align-items-center p-3"
                              >
                                <div class="flex">
                                  <div class="stakeholder">{{ lodash.startCase($t(`${resourceRoute}.partner`)) }}</div>
                                  <div class="name">
                                    <router-link :to="`/customers/${(model.customer || {}).id}`">
                                      {{ lodash.get(model.customer, "name") }}
                                    </router-link>
                                  </div>
                                </div>
                                <div>
                                  <svg
                                      fill="none"
                                      height="25"
                                      viewBox="0 0 30 25"
                                      width="30"
                                      xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                        d="M16.9997 16.6665L15.9663 14.3665L13.6663 13.3332L15.9663 12.2998L16.9997 9.99984L18.033 12.2998L20.333 13.3332L18.033 14.3665L16.9997 16.6665ZM12.9997 9.99984L11.533 6.79984L8.33301 5.33317L11.533 3.8665L12.9997 0.666504L14.4663 3.8665L17.6663 5.33317L14.4663 6.79984L12.9997 9.99984ZM0.333008 24.6665V19.3332C0.333008 18.5776 0.594341 17.9443 1.11701 17.4332C1.63967 16.9221 2.26723 16.6665 2.99967 16.6665H7.36634C7.81079 16.6665 8.23301 16.7776 8.63301 16.9998C9.03301 17.2221 9.35523 17.5221 9.59967 17.8998C10.2441 18.7665 11.0388 19.4443 11.9837 19.9332C12.9286 20.4221 13.9339 20.6665 14.9997 20.6665C16.0886 20.6665 17.1055 20.4221 18.0503 19.9332C18.9952 19.4443 19.7783 18.7665 20.3997 17.8998C20.6886 17.5221 21.0277 17.2221 21.417 16.9998C21.8063 16.7776 22.2117 16.6665 22.633 16.6665H26.9997C27.7552 16.6665 28.3886 16.9221 28.8997 17.4332C29.4108 17.9443 29.6663 18.5776 29.6663 19.3332V24.6665H20.333V21.6332C19.5552 22.1887 18.7161 22.6109 17.8157 22.8998C16.9152 23.1887 15.9766 23.3332 14.9997 23.3332C14.0441 23.3332 13.1108 23.1829 12.1997 22.8825C11.2886 22.5821 10.4441 22.1545 9.66634 21.5998V24.6665H0.333008ZM4.33301 15.3332C3.2219 15.3332 2.27745 14.9443 1.49967 14.1665C0.721897 13.3887 0.333008 12.4443 0.333008 11.3332C0.333008 10.1998 0.721897 9.24961 1.49967 8.4825C2.27745 7.71539 3.2219 7.33228 4.33301 7.33317C5.46634 7.33317 6.41656 7.71673 7.18367 8.48384C7.95079 9.25095 8.3339 10.2007 8.33301 11.3332C8.33301 12.4443 7.94945 13.3887 7.18234 14.1665C6.41523 14.9443 5.46545 15.3332 4.33301 15.3332ZM25.6663 15.3332C24.5552 15.3332 23.6108 14.9443 22.833 14.1665C22.0552 13.3887 21.6663 12.4443 21.6663 11.3332C21.6663 10.1998 22.0552 9.24961 22.833 8.4825C23.6108 7.71539 24.5552 7.33228 25.6663 7.33317C26.7997 7.33317 27.7499 7.71673 28.517 8.48384C29.2841 9.25095 29.6672 10.2007 29.6663 11.3332C29.6663 12.4443 29.2828 13.3887 28.5157 14.1665C27.7486 14.9443 26.7988 15.3332 25.6663 15.3332Z"
                                        fill="#1B77DF"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{ $t(`${this.resourceRoute}.ticket_id`) }}
                            </div>
                            <div class="col-md-6 value">
                              <router-link
                                  :to="`/tickets/${model.ticketable.ticket.id}`"
                              >{{
                                  `${model.ticketable.ticket.id} (${this.$t(
                                      `tickets.customer_types.${model.ticketable.ticket.customer_type}`
                                  )})`
                                }}
                              </router-link
                              >
                            </div>
                          </div>
                          <div class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{ $t(`${this.resourceRoute}.purchase_order_id`) }}
                            </div>
                            <div class="col-md-6 value">
                              {{ model.id }}
                            </div>
                          </div>
                          <div v-if="!isDownPaymentInvoice" class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              Nomor Nota Armada
                            </div>
                            <div class="col-md-6 value">
                              <template v-if="trips.length > 0">
                                <template v-for="(trip, index) in trips">
                                  <router-link v-bind:key="trip.id" :to="`/trips/${trip.id}`">
                                    {{ tripLabel(trip) }}<span v-if="index < trips.length-1">, </span>
                                  </router-link>
                                </template>
                              </template>
                              <template v-else>
                                -
                              </template>
                            </div>
                          </div>
                          <div v-if="!isDownPaymentInvoice && model.ticketable.ticket.customer_type != 'brs'"
                               class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              Tujuan Bongkar
                            </div>
                            <div class="col-md-6 value d-flex gap-1">
                              <div v-if="(trips || []).length > 0">
                                <div
                                    v-for="trip in trips"
                                    v-bind:key="trip.id"
                                >
                                  <router-link
                                      :to="trip.unload ? `/unloads/${(trip.unload || {}).id}` : '#'"

                                  >{{ trip.customer.name }} ({{ trip.customer.code }})
                                  </router-link>
                                </div>
                              </div>
                              <span v-else>-</span>
                            </div>
                          </div>
                          <div v-if="!isDownPaymentInvoice" class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              Nomor Nota Penjualan
                            </div>
                             <div class="col-md-6 value">
                               <template v-if="uniqueSaleOrders.length > 0">
                                 <template v-for="(saleOrder, index) in uniqueSaleOrders">
                                   <router-link v-bind:key="saleOrder.id" :to="`/sale_notes/${saleOrder.id}`">
                                     {{ saleOrderLabel(saleOrder) }}<span v-if="index < uniqueSaleOrders.length-1">, </span>
                                   </router-link>
                                 </template>
                               </template>
                               <template v-else>
                                 -
                               </template>
                            </div>
                          </div>
                          <div class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{
                                $t(
                                    `${resourceRoute}.${
                                        isDownPaymentInvoice
                                            ? "estimated_ordered_at"
                                            : "ordered_at"
                                    }`
                                )
                              }}
                            </div>
                            <div class="col-md-6 value">
                              {{
                                $moment
                                    .utc(model.ordered_at)
                                    .local()
                                    .format("DD MMMM YYYY")
                              }}
                            </div>
                          </div>
                          <div class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{ lodash.upperFirst($t('products.singular')) }}
                            </div>
                            <div class="col-md-6 value">
                              {{ model.product.name }}
                            </div>
                          </div>
                          <div class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{ lodash.upperFirst($t('purchase_orders.service_fee')) }}
                            </div>
                            <div class="col-md-6 value">
                              {{ $numeral(model.service_fee).format('$ 0,0.[00]') }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-12" style="height: 6rem">
                            <div class="card border-0 overflow-hidden mb-1">
                              <div
                                  class="badge-container-warning d-flex justify-content-between align-items-center p-3"
                              >
                                <div class="flex">
                                  <div class="stakeholder">Petambak</div>
                                  <div class="name">
                                    <router-link :to="`/customers/${(model.farmer || {}).id}`">
                                      {{ lodash.get(model.farmer, "name") }}
                                    </router-link>
                                  </div>
                                </div>
                                <div>
                                  <!-- <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M15.9552 31.9999C12.7996 32.0003 9.71477 31.0648 7.09088 29.3117C4.46699 27.5587 2.42193 25.0668 1.21435 22.1513C0.00676482 19.2359 -0.309081 16.0277 0.306757 12.9327C0.922594 9.83772 2.44245 6.99488 4.67409 4.76376C6.15122 3.26274 7.9109 2.06901 9.85164 1.25142C11.7924 0.433835 13.8758 0.00856044 15.9817 0.000127913C18.0876 -0.00830461 20.1743 0.400271 22.1215 1.20229C24.0688 2.00431 25.8379 3.18391 27.3271 4.67305C28.8162 6.16219 29.9957 7.93142 30.7977 9.87868C31.5997 11.826 32.0083 13.9127 31.9999 16.0187C31.9914 18.1246 31.5662 20.2081 30.7486 22.1489C29.931 24.0896 28.7373 25.8494 27.2363 27.3265C25.7584 28.8128 24.0003 29.9911 22.0639 30.7933C20.1275 31.5954 18.0512 32.0056 15.9552 31.9999ZM9.13574 21.9462V24.2935H23.8181V21.9504L9.13574 21.9462ZM6.60331 10.5579L9.19924 17.4082V21.3472H23.8319V17.3087L26.0204 10.633L19.6602 13.0978L16.3171 7.79259L12.7085 13.3624L6.60331 10.5579Z"
                                      fill="#FF9D0B"
                                    />
                                  </svg> -->
                                  <img v-if="model.pro_cycle" :src="JalaProIcon" style="width: 32px;">
                                  <img v-else-if="(model.farm || {}).use_jala_farm" :src="JalaAppIcon"
                                       style="width: 32px;">
                                  <img v-else :src="JalaHarvestIcon" style="width: 32px;">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{ $t(`${this.resourceRoute}.odoo_purchase_orders.state`) }}
                            </div>
                            <div class="col-md-6 value">
                              <status-badge
                                  v-if="odooState != '-'"
                                  :key="odooState"
                                  entity="odoo_purchase_order"
                                  type="status"
                                  :status="odooState"
                              />
                              <span v-else>{{ odooState }}</span>
                            </div>
                          </div>
                          <div class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{ $t(`${this.resourceRoute}.odoo_purchase_orders.invoice_status`) }}
                            </div>
                            <div class="col-md-6 value">
                              <status-badge
                                  v-if="odooInvoiceStatus != '-'"
                                  :key="odooInvoiceStatus"
                                  entity="odoo_purchase_order"
                                  type="invoice_status"
                                  :status="odooInvoiceStatus"
                              />
                              <span v-else>{{ odooInvoiceStatus }}</span>
                            </div>
                          </div>
                          <div v-if="model.ticketable.ticket.customer_type === 'brs'" class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{ $t(`${this.resourceRoute}.top`) }}
                            </div>
                            <div class="col-md-6 value">
                              {{ (this.model.duration ? `${this.model.duration} ${$t('units.days')}` : '-') }}
                            </div>
                          </div>
                          <div v-if="!isDownPaymentInvoice" class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{ $t(`${this.resourceRoute}.hatchery`) }}
                            </div>
                            <div class="col-md-6 value">
                              {{ (this.model.hatchery || {}).name || "-" }}
                            </div>
                          </div>
                          <div v-if="!isDownPaymentInvoice" class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              {{ $t(`${resourceRoute}.feed`) }}
                            </div>
                            <div class="col-md-6 value">
                              {{ feedProductNames || "-" }}
                            </div>
                          </div>
                          <div class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              Nama Tambak
                            </div>
                            <div class="col-md-6 value">
                              <template v-if="model.farm">
                                {{ [model.farm.name, model.farm.region_full_name].join(' - ') }}
                              </template>
                              <template v-else>
                                -
                              </template>
                            </div>
                          </div>
                          <div class="row col-md-12 py-3">
                            <div class="col-md-6 label">
                              Wilayah Panen
                            </div>
                            <div class="col-md-6 value">
                              <template v-if="model.harvest_zone">
                                {{ model.harvest_zone.zone.code }}
                              </template>
                              <template v-else>
                                -
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div
                        style="display: flex;flex-direction: column;justify-content: end; margin-top: 6rem;">
                      <template v-if="model.invoice_documents.length">
                        <div class="fw-bold">Attachment</div>
                        <template v-for="(file, index) in model.invoice_documents">
                          <div :key="index" class="mt-3">
                            <PreviewImagePdf :format="(file || {}).extension" :preview="(file || {}).url"
                                             :preview-pdf="false"/>
                          </div>
                        </template>
                      </template>
                      <span v-if="model.invoice_documents.length" class="mb-3"></span>
                      <template v-if="model.down_payment_documents.length">
                        <div class="fw-bold">Dokumen Down Payment</div>
                        <template v-for="(file, index) in model.down_payment_documents">
                          <div :key="index" class="mt-3">
                            <PreviewImagePdf :key="index" :format="(file || {}).extension" :preview="(file || {}).url"
                                             :preview-pdf="false"/>
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="row border-top pt-3 mt-3 gap-4">
                  <div v-if="model.purchase_items.length" class="col-md-12">
                    <div class="label">
                      Item Nota Panen
                    </div>
                    <div class="border overflow-hidden rounded">
                      <b-table-simple borderless>
                        <b-thead>
                          <b-tr>
                            <b-th>ID</b-th>
                            <b-th>{{ lodash.startCase($t('purchase_orders.quality')) }}</b-th>
                            <b-th class="text-end">{{ lodash.startCase($t('purchase_orders.doc')) }}</b-th>
                            <b-th class="text-end">
                              {{ `${this.lodash.startCase(this.$t("purchase_items.quantity"))} (${this.$t("kg")})` }}
                            </b-th>
                            <b-th v-if="isLcsTicket" class="text-end">{{
                                `${this.lodash.startCase(this.$t("purchase_items.untransported_biomass"))} (${this.$t("kg")})`
                              }}
                            </b-th>
                            <b-th class="text-end">{{ lodash.startCase($t('purchase_orders.size')) }}</b-th>
                            <b-th class="text-end">{{ lodash.startCase($t('purchase_orders.unit_price')) }}</b-th>
                            <b-th class="text-end">{{ lodash.startCase($t('purchase_orders.total_price')) }}</b-th>
                          </b-tr>
                        </b-thead>
                        <template v-if="isLcsTicket">
                          <b-tbody>
                            <b-tr v-for="(item) in model.purchase_items" :key="item.id">
                              <b-td>{{ item.id }}</b-td>
                              <b-td>{{ $t(`qualities.${item.quality}`) }}</b-td>
                              <b-td class="text-end">{{ item.doc || '-' }}</b-td>
                              <b-td class="text-end">{{ $numeral(item.quantity).format('0,0.[00]') }}</b-td>
                              <b-td class="text-end">{{ $numeral(item.available_quantity).format('0,0.[00]') }}</b-td>
                              <b-td class="text-end">{{ $numeral(item.size).format('0,0.[00]') }}</b-td>
                              <b-td class="text-end">{{ $numeral(item.unit_price).format('$ 0,0.[00]') }}</b-td>
                              <b-td class="text-end">{{ $numeral(item.total_price).format('$ 0,0.[00]') }}</b-td>
                            </b-tr>
                          </b-tbody>
                          <b-tfoot>
                            <b-tr>
                              <b-th></b-th>
                              <b-th>Total</b-th>
                              <b-th></b-th>
                              <b-th class="text-end">{{
                                  $numeral(model.purchase_item_total_quantity).format('0,0.[00]')
                                }}
                              </b-th>
                              <b-th class="text-end">
                                {{ $numeral(model.purchase_item_total_available_quantity).format('0,0.[00]') }}
                              </b-th>
                              <b-th></b-th>
                              <b-th></b-th>
                              <b-th class="text-end" style="width: 200px">{{
                                  $numeral(purchaseItemTotal).format('$ 0,0.[00]')
                                }}
                              </b-th>
                            </b-tr>
                          </b-tfoot>
                        </template>
                        <template v-else>
                          <b-tbody>
                            <b-tr v-for="(item) in model.purchase_items" :key="item.id">
                              <b-td>{{ item.id }}</b-td>
                              <b-td>{{ $t(`qualities.${item.quality}`) }}</b-td>
                              <b-td class="text-end">{{ item.doc || '-' }}</b-td>
                              <b-td class="text-end">{{ $numeral(item.quantity).format('0,0.[00]') }}</b-td>
                              <b-td class="text-end">{{ $numeral(item.size).format('0,0.[00]') }}</b-td>
                              <b-td class="text-end">{{ $numeral(item.unit_price).format('$ 0,0.[00]') }}</b-td>
                              <b-td class="text-end">{{ $numeral(item.total_price).format('$ 0,0.[00]') }}</b-td>
                            </b-tr>
                          </b-tbody>
                          <b-tfoot>
                            <b-tr>
                              <b-th></b-th>
                              <b-th>Total</b-th>
                              <b-th></b-th>
                              <b-th class="text-end">{{
                                  $numeral(model.purchase_item_total_quantity).format('0,0.[00]')
                                }}
                              </b-th>
                              <b-th></b-th>
                              <b-th></b-th>
                              <b-th class="text-end">{{
                                  $numeral(purchaseItemTotal).format('$ 0,0.[00]')
                                }}
                              </b-th>
                            </b-tr>
                          </b-tfoot>
                        </template>
                      </b-table-simple>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div v-if="model.purchase_items" class="row">
                      <div v-if="additionalFeeItems.length" class="col-md-6">
                        <div class="label">
                          {{ $t(`${resourceRoute}.additional_fee`) }}
                        </div>
                        <div class="border overflow-hidden rounded">
                          <b-table
                              v-if="additionalFeeItems.length"
                              :fields="purchaseAdditionalItemsFields"
                              :items="additionalFeeItems"
                              borderless
                              responsive
                          >
                            <template #cell(index)="data">{{ data.index + 1 }}</template>
                          </b-table>
                          <div v-else>-</div>
                        </div>
                      </div>
                      <div v-if="discountItems.length" class="col-md-6">
                        <div class="label">
                          {{ $t(`${resourceRoute}.discount`) }}
                        </div>
                        <div class="border overflow-hidden rounded">
                          <b-table
                              v-if="discountItems.length"
                              :fields="purchaseAdditionalItemsFields"
                              :items="discountItems"
                              borderless>
                            <template #cell(index)="data">{{ data.index + 1 }}</template>
                          </b-table>
                          <div v-else>-</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 row">
                      <div v-if="model.purchase_operational_costs.length && model.type === 'harvest'"
                           class="col-md-6">
                        <div class="label">
                          {{ lodash.startCase($t(`operational_costs.singular`)) }}
                        </div>
                        <div class="border overflow-hidden rounded">
                          <b-table
                              :fields="operationalCostsField"
                              :items="model.purchase_operational_costs"
                              borderless>
                            <template #cell(index)="data">{{ data.index + 1 }}</template>
                          </b-table>
                        </div>
                      </div>
                      <div v-if="model.operational_cost_document" class="col-md-6">
                        <div class="label">
                          Attachment
                        </div>
                        <PreviewImagePdf
                            :format="(model.operational_cost_document || {}).extension"
                            :preview="(model.operational_cost_document || {}).url"/>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <b-table-simple borderless>
                        <b-tbody>
                          <b-tr>
                            <b-th class="text-end label text-success" style="font-weight: 800">{{ lodash.upperCase($t('purchase_orders.grand_total')) }}</b-th>
                            <b-th class="text-end text-success" style="font-weight: 800; width: 200px">{{ $numeral(model.total).format('$ 0,0.[00]')}}</b-th>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                      <div class="text-end" style="padding-right: 24px">
                        <b style="font-weight: 700"><span class="me-2"></span> </b>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-3 gap-4">
                  <b-card-text v-if="model.down_payment" class="custom-group">
                    <div class="label">{{ $t(`${resourceRoute}.down_payment`) }}</div>
                    <span class="value no-colon">{{ $numeral(model.down_payment).format("$ 0,0.[000]") }}</span>
                  </b-card-text>
                  <b-card-text class="custom-group">
                    <div class="label">{{ lodash.startCase($t(`models.description`)) }}</div>
                    <span class="value no-colon">
                      <div><span v-html="model.description || '-'"></span></div>
                    </span>
                  </b-card-text>
                </div>
                <div>
                  <b-card-text class="custom-group">
                    <div class="label">{{ lodash.startCase($t(`${resourceRoute}.change_history`)) }}</div>
                    <div :class="{'scrollable-container': formattedActivityLogs.length > maxActivityToShowOnCollapse}">
                      <ul id="activity-log-list" class="mb-0" style="margin-left: -12px">
                        <li
                            class="mt-2"
                            v-for="(formattedActivityLog, index) in formattedActivityLogToShow"
                            :key="`activity-logs-${index}`"
                            v-html="formattedActivityLog"
                        >
                        </li>
                      </ul>
                    </div>
                    <template v-if="formattedActivityLogs.length > maxActivityToShowOnCollapse">
                      <b-link
                          class="activity-log-collapse"
                          href="#" v-if="activityLogCollapse"
                          @click="activityLogCollapse = !activityLogCollapse"
                      >
                        {{ lodash.startCase($t('show_more')) }}
                      </b-link>
                      <b-link
                          class="activity-log-collapse"
                          href="#"
                          v-else
                          @click="activityLogCollapse = !activityLogCollapse"
                      >
                        {{ lodash.startCase($t('show_less')) }}
                      </b-link>
                    </template>
                  </b-card-text>
                </div>
              </b-card-body>
            </b-card>
          </div>
        </div>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelShow from "../models/show";
import Row from "@/components/models/show/custom-row";
import FailedToFetchModal from "@/router/views/purchase_orders/modals/FailedToFetchModal.vue";
import TimeoutRequestModal from "@/router/views/purchase_orders/modals/TimeoutRequestModal.vue";
import Loader from '@/components/widgets/loader'
import StatusBadge from "@/components/badges/status-badge.vue";
import router from "@/router";
import Swal from "sweetalert2";
import purchaseOrder from "@/router/views/sale_notes/show/resumes/purchase-order.vue";
import {hasAllowedAction as hasAllowedActionHelper} from "@/helpers/ui/allowedActions";

export default {
  extends: ModelShow,
  page: {
    title: "Detail Purchase Orders",
  },
  components: {
    Loader,
    FailedToFetchModal,
    StatusBadge,
    TimeoutRequestModal,
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("purchase_orders.singular"));
      },
    },
    resourceRoute: {default: "purchase_orders"},
    modelVariable: {default: "purchase_order"},
    denyEdit: {type: Boolean, default: false},
    denyDelete: {type: Boolean, default: true},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row,
            },
          ],
        };
      },
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("purchase_orders.plural")),
      activity_logs: [],
      activityLogCollapse: true,
      maxActivityToShowOnCollapse: 15,
      failedFetchShow: false,
      timeoutRequestModalShow: false,
    };
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    isEditDisabled() {
      if (this.denyEdit === true) {
        return true;
      }

      return !hasAllowedActionHelper(this.model, ["edit", "update"]);
    },
    purchaseOrder() {
      return purchaseOrder
    },
    purchaseItemTotal() {
      return this.model.purchase_items.reduce((carry, {total_price}) => carry + total_price, 0)
    },
    odooState() {
      return this.model.odoo_purchase_order?.state ?? '-'
    },
    odooInvoiceStatus() {
      return this.model.odoo_purchase_order?.invoice_status ?? '-'
    },
    feedProductNames() {
      return this.model.feed_products.map(({name}) => name).join(', ')
    },
    formattedActivityLogToShow() {
      return this.activityLogCollapse ? this.formattedActivityLogs.slice(0, this.maxActivityToShowOnCollapse): this.formattedActivityLogs
    },
    formattedActivityLogs() {
      return this.activity_logs
          .map(activity_log => {
            let {subject_type} = activity_log;
            if (subject_type === 'App\\Models\\PurchaseAdditionalItem') {
              return this.formattedPurchaseAdditionalItemActivityLog(activity_log)
            } else if (subject_type === 'App\\Models\\PurchaseItem') {
              return this.formattedPurchaseItemActivityLogs(activity_log)
            }
            return this.formattedPurchaseOrderLogs(activity_log)
          }).flat(1) ?? [];
    },
    isDownPaymentInvoice() {
      return this.model.type === 'down_payment'
    },
    tripIds() {
      // model.purchase_items.trip_items.trip_id (possible null)
      let trip_items = this.model.purchase_items.map((i) => [i.trip_items[0]]).flat();
      let trip_ids = trip_items.map((i) => i.trip_id);
      // return unique trip_ids
      trip_ids = [...new Set(trip_ids)];
      // separate trip_ids by comma
      return trip_ids;
    },
    trips() {
      // same as tripIds, but return trip object
      let trip_items = this.model.purchase_items.map((i) => i.trip_items).flat();
      let trips = trip_items.map((i) => i.trip);
      const uniqueTrips = []
      trips.forEach((trip) => {
        if (!uniqueTrips.find((item) => item.id === trip.id)) {
          uniqueTrips.push(trip);
        }
      })
      return uniqueTrips;
    },
    isLcsTicket() {
      return this.model.ticketable?.ticket?.customer_type === 'lcs'
    },
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t("purchase_orders.plural")),
          href: "/purchase_orders",
        },
        {
          text:
              this.model && this.model.id
                  ? this.model.order_id
                  : this.$route.params.key,
          href: `/purchase_orders/${this.$route.params.key}`,
          active: true,
        },
      ];
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model)
          ? []
          : [
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.ticket_id`)
              ),
              item: this.model.ticketable.ticket,
              value: {
                props: {
                  item: {
                    type: Object, default: () => {
                    }
                  }
                },
                template:
                    '<div><router-link :to="`/tickets/${item.id}`">{{ `${item.id} (${this.$t(`tickets.customer_types.${item.customer_type}`)})` }}</router-link></div>',
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.purchase_order_id`)
              ),
              value: this.model.id,
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(
                  this.$t(
                      `${this.resourceRoute}.${this.isDownPaymentInvoice ? "estimated_ordered_at" : "ordered_at"
                      }`
                  )
              ),
              value: this.$moment
                  .utc(this.model.ordered_at)
                  .local()
                  .format("DD MMMM YYYY"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.partner`)
              ),
              item: this.model.customer,
              value: {
                props: {
                  item: {
                    type: Object, default: () => {
                    }
                  }
                },
                template:
                    '<div><router-link :to="`/customers/${item.id}`">{{ lodash.get(item, "name") }}</router-link></div>',
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.from_farmer`)
              ),
              item: this.model.farmer,
              value: {
                props: {
                  item: {
                    type: Object, default: () => {
                    }
                  }
                },
                template:
                    '<div><router-link v-if="item" :to="`/customers/${item.id}`">{{ lodash.get(item, "name") }}</router-link><span v-else>-</span></div>',
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t('products.singular')),
              item: this.model.product,
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                },
                template: `
                  <div><span v-html="item.name || '-'"></span></div>`,
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.shrimp_origin`)
              ),
              item: (this.model.purchase_items[0] || {}).shrimp_origin,
              value: {
                props: {item: {type: String}},
                template: `
                  <div><span v-html="item || '-'"></span></div>`,
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.$t(`${this.resourceRoute}.feed`),
              item: this.model.feed,
              value: {
                props: {item: {type: String}},
                template: `
                  <div><span v-html="item || '-'"></span></div>`,
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t(`${this.resourceRoute}.file`)),
              item: this.model.files,
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                template: `
                  <div class="col-md-6">
                    <PreviewImagePdf :preview="(item[0] || {}).url" :format="(item[0] || {}).extension"/>
                  </div>`,
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              denyShow: !!this.model.down_payment,
            },
            {
              key: this.$t(`files`),
              item: this.model,
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  downPaymentDocumentFile() {
                    return this.item.files.find(
                        (v) => v.name === "down payment document"
                    );
                  },
                  invoiceDocumentFile() {
                    return this.item.files.find(
                        (v) => v.name !== "down payment document"
                    );
                  },
                },
                template:
                    '<div class="row">' +
                    '<div v-if="!lodash.isEmpty(downPaymentDocumentFile)" class="col-md-6"><p>{{ lodash.startCase($t("purchase_orders.down_payment_document")) }}</p><PreviewImagePdf :preview="downPaymentDocumentFile.url" :format="downPaymentDocumentFile.extension"/></div>' +
                    '<div v-if="!lodash.isEmpty(invoiceDocumentFile)" class="col-md-6"><p>{{ lodash.startCase($t("purchase_orders.invoice_document")) }}</p><PreviewImagePdf :preview="invoiceDocumentFile.url" :format="invoiceDocumentFile.extension"/></div>' +
                    "</div>",
              },
              denyShow: !this.model.down_payment,
            },
            // {
            //   key: this.lodash.startCase(this.$t(`files`)),
            //   items: this.model.files,
            //   value: {
            //     props: { items: {type: Array, default() { return [] }} },
            //     template: '<div class="row">' +
            //         '<div v-for="(i, key) in items" class="col-md-6">' +
            //         '<p>File {{key + 1}}</p>' +
            //         '<PreviewImagePdf :preview="i.url" :format="i.extension"/>' +
            //         '</div>' +
            //         '</div>'
            //   }
            // },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.purchase_items`)
              ),
              item: this.model.purchase_items,
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "index",
                        label: "No",
                        sortable: false,
                        style: {width: "1%"},
                      },
                      {
                        key: "quality",
                        label: `${this.lodash.startCase(
                            this.$t("purchase_orders.quality")
                        )}`,
                        formatter: (value) => this.$t(`qualities.${value}`),
                      },
                      {
                        key: "doc",
                        label: `${this.$t("purchase_items.DoC")}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        formatter: (value) => (value ? value : "-"),
                      },
                      {
                        key: "quantity",
                        label: `${this.lodash.startCase(
                            this.$t("purchase_items.quantity")
                        )} (${this.$t("kg")})`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        formatter: (value) =>
                            this.$numeral(value).format("0,0.[00]"),
                      },
                      {
                        key: "size",
                        label: `${this.lodash.startCase(
                            this.$t("purchase_items.size")
                        )}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        formatter: (value) =>
                            this.$numeral(value).format("0,0.[00]"),
                      },
                      {
                        key: "unit_price",
                        label: this.lodash.startCase(
                            this.$t("purchase_items.unit_price")
                        ),
                        thClass: "text-end",
                        tdClass: "text-end",
                        formatter: (value) =>
                            this.$numeral(value).format("$ 0,0.[00]"),
                      },
                      {
                        key: "total_price",
                        label: this.lodash.startCase(
                            this.$t("purchase_items.total_price")
                        ),
                        thClass: "text-end",
                        tdClass: "text-end",
                        formatter: (value) =>
                            this.$numeral(value).format("$ 0,0.[00]"),
                      },
                      this.model.ticketable.ticket.customer_type === 'lcs' ?
                          {
                            key: "available_quantity",
                            label: `${this.lodash.startCase(
                                this.$t("purchase_items.untransported_biomass")
                            )} (${this.$t("kg")})`,
                            thClass:
                                "text-end " + (this.item[0].$hide ? "d-none" : ""),
                            tdClass:
                                "text-end " + (this.item[0].$hide ? "d-none" : ""),
                            denyShow: false,
                            thStyle: {width: "160px !important"},
                            formatter: (value) =>
                                this.$numeral(value).format("0,0.[000]"),
                          } : null,
                    ];
                  },
                },
                template:
                    '<b-table :fields="fields" :items="item" v-if="item.length">' +
                    '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                    "</b-table><div v-else>-</div>",
              },
              denyShow: this.isDownPaymentInvoice,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.additional_fee`)
              ),
              item: this.model.purchase_additional_items.filter(
                  (i) => i.total > 0
              ),
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "index",
                        label: "No",
                        sortable: false,
                        style: {width: "1%"},
                      },
                      {
                        key: "name",
                        label: `${this.lodash.startCase(
                            this.$t("additional_fees.name")
                        )}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: {width: "50%"},
                      },
                      {
                        key: "total",
                        label: `${this.lodash.startCase(
                            this.$t("additional_fees.total")
                        )}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: {width: "50%"},
                        formatter: (value) =>
                            this.$numeral(value).format("$ 0,0.[00]"),
                      },
                    ];
                  },
                },
                template:
                    '<b-table :fields="fields" :items="item" v-if="item.length">' +
                    '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                    "</b-table><div v-else>-</div>",
              },
              denyShow:
                  this.isDownPaymentInvoice ||
                  this.model.purchase_additional_items.filter((i) => i.total > 0)
                      .length === 0,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.discount`)
              ),
              item: this.model.purchase_additional_items.filter(
                  (i) => i.total < 0
              ),
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "index",
                        label: "No",
                        sortable: false,
                        style: {width: "1%"},
                      },
                      {
                        key: "name",
                        label: `${this.lodash.startCase(
                            this.$t("additional_fees.name")
                        )}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: {width: "50%"},
                      },
                      {
                        key: "total",
                        label: `${this.lodash.startCase(
                            this.$t("additional_fees.total")
                        )}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: {width: "50%"},
                        formatter: (value) =>
                            this.$numeral(Math.abs(value)).format("$ 0,0.[00]"),
                      },
                    ];
                  },
                },
                template:
                    '<b-table :fields="fields" :items="item" v-if="item.length">' +
                    '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                    "</b-table><div v-else>-</div>",
              },
              denyShow:
                  this.isDownPaymentInvoice ||
                  this.model.purchase_additional_items.filter((i) => i.total < 0)
                      .length === 0,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.total_biomassa`)
              ),
              value:
                  this.model.purchase_items.length > 0
                      ? `${this.$numeral(
                          this.model.purchase_item_total_quantity
                      ).format("0,0.[000]")} ${this.$t("units.kg")}`
                      : "-",
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              denyShow: this.isDownPaymentInvoice,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.down_payment`)
              ),
              value: this.$numeral(this.model.down_payment).format(
                  "$ 0,0.[00]"
              ),
              class: `row ${this.model.down_payment > 0 ? "" : "d-none"}`,
              // labelItemStyles: {fontStyle: 'italic'},
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              denyShow: !this.model.down_payment,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.total_price`)
              ),
              value: this.$numeral(this.model.total).format("$ 0,0.[00]"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              denyShow: this.isDownPaymentInvoice,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.operational_cost_file`)
              ),
              item: this.model.files,
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  file() {
                    return this.item.find(
                        ({name}) => name === "operational cost document"
                    );
                  },
                },
                template: `
                  <div class="col-md-6" v-if="!lodash.isEmpty(file)">
                    <PreviewImagePdf :preview="(file|| {}).url" :format="(file || {}).extension"/>
                  </div>
                  <div v-else>-</div>`,
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              denyShow: this.model?.ticket?.customer_type === "brs",
            },
            {
              key: this.lodash.startCase(this.$t(`operational_costs.singular`)),
              item: this.model.operational_costs.filter((i) => i.total > 0),
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  glazingCost() {
                    let cost = this.item.find(
                        ({name}) => name?.toLowerCase() === "ice"
                    );
                    if (this.lodash.isEmpty(cost)) return null;
                    return {
                      ...cost,
                      name: "Glazing",
                    };
                  },
                  shippingCost() {
                    let cost = this.item.find(
                        ({name}) => name?.toLowerCase() === "delivery"
                    );
                    if (this.lodash.isEmpty(cost)) return null;
                    return {
                      ...cost,
                      name: "Shipping cost",
                    };
                  },
                  labourCost() {
                    let cost = this.item.find(
                        ({name}) => name?.toLowerCase() === "labour"
                    );
                    if (this.lodash.isEmpty(cost)) return null;
                    return {
                      ...cost,
                      name: "Labour cost",
                    };
                  },
                  otherCosts() {
                    return this.item.filter(
                        ({name}) =>
                            !["ice", "delivery", "labour"].includes(
                                name?.toLowerCase()
                            )
                    );
                  },
                  tableItems() {
                    let items = [...this.otherCosts];

                    if (!this.lodash.isEmpty(this.glazingCost)) {
                      items.push(this.glazingCost);
                    }
                    if (!this.lodash.isEmpty(this.shippingCost)) {
                      items.push(this.shippingCost);
                    }
                    if (!this.lodash.isEmpty(this.labourCost)) {
                      items.push(this.labourCost);
                    }

                    return this.lodash.sortBy(items, ["name"], ["asc"]);
                  },
                  fields() {
                    return [
                      {
                        key: "index",
                        label: "No",
                        sortable: false,
                        style: {width: "1%"},
                      },
                      {
                        key: "name",
                        label: `${this.lodash.startCase(
                            this.$t("additional_fees.name")
                        )}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: {width: "50%"},
                      },
                      {
                        key: "total",
                        label: `${this.lodash.startCase(
                            this.$t("additional_fees.total")
                        )}`,
                        thClass: "text-end",
                        tdClass: "text-end",
                        thStyle: {width: "50%"},
                        formatter: (value) =>
                            this.$numeral(value).format("$ 0,0.[00]"),
                      },
                    ];
                  },
                },
                template:
                    '<b-table :fields="fields" :items="tableItems" v-if="item.length">' +
                    '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                    "</b-table><div v-else>-</div>",
              },
              denyShow:
                  !this.model.ticketable.ticket.customer_type.toLowerCase() ===
                  "brs" ||
                  this.model.operational_costs.filter((i) => i.total > 0)
                      .length === 0,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.sub_total`)
              ),
              value: this.$numeral(
                  (this.isDownPaymentInvoice
                      ? this.model.down_payment
                      : this.model.total) + this.model.operational_cost_total
              ).format("$ 0,0.[00]"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              denyShow:
                  !this.model.ticketable.ticket.customer_type.toLowerCase() ===
                  "brs" ||
                  this.model.operational_costs.filter((i) => i.total > 0)
                      .length === 0,
            },
            {
              key: this.lodash.startCase(this.$t(`models.description`)),
              item: this.model.description,
              value: {
                props: {item: {type: String, default: ""}},
                template: `
                  <div><span v-html="item || '-'"></span></div>`,
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t(`CreatedBy`)),
              value: this.lodash.startCase(this.model.creator.name || "-"),
              class: "row",
              styles: "font-size:10px;opacity:0.8",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(
                  this.$t(
                      this.model.down_payment
                          ? `${this.resourceRoute}.down_payment_created_at`
                          : `${this.resourceRoute}.created_at`
                  )
              ),
              value: this.$moment
                  .utc(this.model.created_at)
                  .local()
                  .format("DD MMMM YYYY"),
              class: "row",
              styles: "font-size:10px;opacity:0.8",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.actual_invoice_date`)
              ),
              value: this.$moment
                  .utc(this.model.created_at)
                  .local()
                  .format("DD MMMM YYYY"),
              class: "row",
              styles: "font-size:10px;opacity:0.8",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              denyShow: this.model.actual_invoice_date === null,
            },
          ].filter((i) => i.denyShow !== true);
    },
    purchaseAdditionalItemsFields() {
      return [
        {
          key: "id",
          label: "ID",
          sortable: false,
          style: {width: "5%"},
        },
        {
          key: "name",
          label: `${this.lodash.startCase(
              this.$t("additional_fees.name")
          )}`,
          thClass: "text-end",
          tdClass: "text-end",
          thStyle: {width: "50%"},
        },
        {
          key: "total",
          label: `${this.lodash.startCase(
              this.$t("additional_fees.total")
          )}`,
          thClass: "text-end",
          tdClass: "text-end",
          thStyle: {width: "50%"},
          formatter: (value) =>
              this.$numeral(value).format("$ 0,0.[00]"),
        },
      ];
    },
    operationalCostsField() {
      return [
        {
          key: "index",
          label: "No",
          sortable: false,
          style: {width: "1%"},
        },
        {
          key: "name",
          label: `${this.lodash.startCase(
              this.$t("additional_fees.name")
          )}`,
          thClass: "text-end",
          tdClass: "text-end",
          thStyle: {width: "50%"},
        },
        {
          key: "amount",
          label: `${this.lodash.startCase(
              this.$t("additional_fees.total")
          )}`,
          thClass: "text-end",
          tdClass: "text-end",
          thStyle: {width: "50%"},
          formatter: (value) =>
              this.$numeral(value).format("$ 0,0.[00]"),
        },
      ];
    },
    additionalFeeItems() {
      return this.model.purchase_additional_items.filter((i) => i.total > 0)
    },
    discountItems() {
      return this.model.purchase_additional_items
          .filter((i) => i.total < 0)
          .map((i) => ({
            ...i,
            total: Math.abs(i.total)
          }))
    },
    sale_payments() {
      const payments = [];
      this.model?.purchase_items.forEach((purchase_item) => {
        purchase_item.sale_items.forEach((sale_item) => {
          sale_item.sale_order?.payments?.forEach((payment) => {
            if (!payments.find((p) => p.id === payment.id)) {
              payments.push(payment)
            }
          })
        })
      })
      return payments;
    },
    uniqueSaleOrders() {
      let saleOrders = this.model?.purchase_items.map(({sale_items}) => sale_items.map(({sale_order}) => sale_order)).flat()
      return this.lodash.uniqBy(saleOrders, 'id')
    }
  },
  methods: {
    showFailedToFetchModal() {
      this.$set(this, 'failedFetchShow', true);
    },
    closeFailedToFetchModal() {
      this.$set(this, 'failedFetchShow', false);
    },
    retryFailedToFetchModal() {
      this.closeFailedToFetchModal()
      this.fetchData()
    },
    showTimeoutRequestModal() {
      this.$set(this, 'timeoutRequestModalShow', true);
    },
    closeTimeoutRequestModal() {
      this.$set(this, 'timeoutRequestModalShow', false);
    },
    retryTimeoutRequestModal() {
      this.closeTimeoutRequestModal()
      this.fetchData()
    },
    fetchData() {
      this.$set(this, 'loading', true)
      return Promise.all([
        this.fetchModel(),
        this.fetchModelActivityLogs()
      ]).then(([purchaseOrderRes, purchaseOrderActivityLogRes]) => {
        let {data: {data: purchaseOrderData}} = purchaseOrderRes
        let {data: {data: purchaseOrderActivityLogData}} = purchaseOrderActivityLogRes

        this.setModelFromFetchData(purchaseOrderData)
        this.setActivityLogs(purchaseOrderActivityLogData)
      }).catch((error) => {
        if (error.code === 'ECONNABORTED') {
          this.showTimeoutRequestModal()
        } else {
          this.showFailedToFetchModal()
        }
      })
          .finally(() => {
            this.$set(this, 'loading', false)
          });
    },
    failedFetchAlert() {
      return Swal.fire({
        title: this.$t('failed_to_fetch_{name}', {name: this.$t('purchase_orders.singular')}),
        text: 'ea',
        type: 'warning',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    },
    formattedPurchaseOrderLogs(purchaseOrderActivityLog) {
      const {description, properties, causer_name} = purchaseOrderActivityLog

      if (description === 'updated') {
        let keys = Object.keys(properties.old)
        return keys.map((key) => {
          const {old, attributes} = properties
          let label = this.lodash.startCase(this.$t(`purchase_orders.${key}`))
          let oldValue = old[key]
          let newValue = attributes[key]

          if (oldValue === newValue) {
            return null
          }

          if (key === 'service_fee') {
            oldValue = this.$numeral(old[key]).format('$ 0,0.[00]')
            newValue = this.$numeral(attributes[key]).format('$ 0,0.[00]')
          }
          if (key === 'markup_kg') {
            label = this.lodash.startCase(this.$t('purchase_orders.mark_up'))
            oldValue = this.$numeral(old[key]).format('$ 0,0.[00]')
            newValue = this.$numeral(attributes[key]).format('$ 0,0.[00]')
          }

          return `<span class="me-2" style="color: #667085">${this.$moment.utc(purchaseOrderActivityLog.created_at).local().format('DD-MM-YYYY HH:mm')}</span>[${label}] <b class="text-danger">${oldValue}</b> -> <b class="text-success">${newValue}</b> <span style="color:#667085">oleh ${causer_name}</span>`
        }).filter((val => val !== null))
      }

      return [`<span class="me-2" style="color: #667085">${this.$moment.utc(purchaseOrderActivityLog.created_at).local().format('DD-MM-YYYY HH:mm')}</span>${this.lodash.startCase(this.$t('purchase_orders.singular'))} <b class="text-success">dibuat</b> <span style="color:#667085">oleh ${causer_name}</span></span>`]
    },
    formattedPurchaseItemActivityLogs(purchaseItemActivityLog) {
      const {description, properties, causer_name, subject_id} = purchaseItemActivityLog
      if (description === 'deleted') {
        let {quality, size, quantity} = properties.old;

        return [`<span class="me-2" style="color: #667085">${this.$moment.utc(purchaseItemActivityLog.created_at).local().format('DD-MM-YYYY HH:mm')}</span>[${this.lodash.startCase(this.$t('purchase_items.singular'))}] <b>${subject_id}</b> - ${this.lodash.startCase(this.$t(`purchase_items.qualities.${quality}`))} ${this.lodash.upperFirst(this.$t('purchase_items.size'))}: ${size}, ${this.lodash.upperFirst(this.$t('purchase_items.quantity'))}: ${quantity} kg <b class="text-danger">telah dihapus</b> <span style="color:#667085">oleh ${causer_name}</span>`]
      } else if (description === 'updated') {
        let keys = Object.keys(properties.old)

        return keys.map((key) => {
          const {old, attributes} = properties
          let oldValue = old[key]
          let newValue = attributes[key]

          if (oldValue === newValue) {
            return null
          }

          if (key === 'quantity') {
            oldValue = `${old[key]} <span style="color: black !important;font-weight: normal !important;">kg</span>`
            newValue = `${attributes[key]} <span style="color: black !important;font-weight: normal !important;">kg</span>`
          } else if (['unit_price', 'total_price'].includes(key)) {
            oldValue = this.$numeral(old[key]).format('$ 0,0.[00]')
            newValue = this.$numeral(attributes[key]).format('$ 0,0.[00]')
          } else if (key === 'quality') {
            oldValue = this.lodash.startCase(this.$t(`purchase_items.qualities.${old[key]}`))
            newValue = this.lodash.startCase(this.$t(`purchase_items.qualities.${attributes[key]}`))
          }

          return `<span class="me-2" style="color: #667085">${this.$moment.utc(purchaseItemActivityLog.created_at).local().format('DD-MM-YYYY HH:mm')}</span>[${this.lodash.startCase(this.$t(`purchase_items.singular`))}] <b>${subject_id}</b> - ${this.lodash.startCase(this.$t(`purchase_items.${key}`))} <b class="text-danger">${oldValue}</b> -> <b class="text-success">${newValue}</b> <span style="color:#667085">oleh ${causer_name}</span>`
        }).filter((val) => val !== null)
      }
      let {quality, size, quantity} = purchaseItemActivityLog.properties.attributes;

      return [`<span class="me-2" style="color: #667085">${this.$moment.utc(purchaseItemActivityLog.created_at).local().format('DD-MM-YYYY HH:mm')}</span>[${this.lodash.startCase(this.$t('purchase_items.singular'))}] <b>${subject_id}</b> - ${this.lodash.startCase(this.$t(`purchase_items.qualities.${quality}`))} ${this.lodash.upperFirst(this.$t('purchase_items.size'))}: ${size}, ${this.lodash.upperFirst(this.$t('purchase_items.quantity'))}: ${quantity} kg <b class="text-success">telah ditambahkan</b> <span style="color:#667085">oleh ${causer_name}</span>`]
    },
    formattedPurchaseAdditionalItemActivityLog(purchaseAdditionalItemLog) {
      const {description, properties, causer_name, subject_id} = purchaseAdditionalItemLog;
      if (description === 'deleted') {
        let {name, total} = purchaseAdditionalItemLog.properties.old;
        return [`<span class="me-2" style="color: #667085">${this.$moment.utc(purchaseAdditionalItemLog.created_at).local().format('DD-MM-YYYY HH:mm')}</span>[${this.lodash.startCase(total > 0 ? this.$t('additional_fees.singular') : this.$t('discounts.singular'))}] <b>${subject_id}</b> - ${name} ${Math.abs(total)} <b class="text-danger">telah dihapus</b> <span style="color:#667085">oleh ${causer_name}</span>`]
      } else if (description === 'updated') {
        let keys = Object.keys(properties.old)

        return keys.map((key) => {
          const {old, attributes} = properties
          let {name, total} = purchaseAdditionalItemLog.properties.attributes;

          let oldValue = old[key]
          let newValue = attributes[key]

          if (oldValue === newValue) {
            return null
          }

          if (key === 'total') {
            oldValue = this.$numeral(Math.abs(old[key])).format('$ 0,0.[00]')
            newValue = this.$numeral(Math.abs(attributes[key])).format('$ 0,0.[00]')
          }

          return `<span class="me-2" style="color: #667085">${this.$moment.utc(purchaseAdditionalItemLog.created_at).local().format('DD-MM-YYYY HH:mm')}</span>[${this.lodash.startCase(total > 0 ? this.$t('additional_fees.singular') : this.$t('discounts.singular'))}] <b>${subject_id}</b> - ${name} <b class="text-danger">${oldValue}</b> -> <b class="text-success">${newValue}</b> <span style="color:#667085">oleh ${causer_name}</span>`
        }).filter(val => val !== null)
      }
      let {name, total} = purchaseAdditionalItemLog.properties.attributes;
      return [`<span class="me-2" style="color: #667085">${this.$moment.utc(purchaseAdditionalItemLog.created_at).local().format('DD-MM-YYYY HH:mm')}</span>[${this.lodash.startCase(total > 0 ? this.$t('additional_fees.singular') : this.$t('discounts.singular'))}] <b>${subject_id}</b> - ${name} ${Math.abs(total)} <b class="text-success">telah ditambahkan</b> <span style="color:#667085">oleh ${causer_name}</span>`]
    },
    router() {
      return router
    },
    tripLabel(trip) {
      if (trip.type === 'hybrid') return trip.id
      let driverName = trip.driver?.name
      let licensePlate = trip.vehicle?.license_plate
      return `${driverName}/${licensePlate}`
    },
    saleOrderLabel(saleOrder) {
      const {id, type_name} = saleOrder
      return `${type_name} - ${id}`
    },
    getModelName() {
      return this.model["order_id"];
    },
    delete() {
      return this.$axios.delete(`/purchase_orders/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
          .get(`/purchase_orders/${this.$route.params.key}`, {
            params: {
              with: [
                "creator",
                "customer",
                "farm",
                "farmer",
                "files",
                "feed_products",
                "harvest_zone.zone",
                "hatchery",
                "odoo_purchase_order",
                "product",
                "purchase_additional_items",
                "purchase_items.sale_items.sale_order.payments",
                "purchase_items.trip_items.trip.customer",
                "purchase_items.trip_items.trip.driver",
                "purchase_items.trip_items.trip.unload.payments",
                "purchase_items.trip_items.trip.vehicle",
                "purchase_operational_costs",
                "ticketable.ticket",
                "trips",
              ].join(','),
            },
            timeout: 30000,
          })
          .then((response) => {
            // const {
            //   data: {data},
            // } = response;
            // this.model = {
            //   ...data,
            //   ordered_at: data.ordered_at || data.estimated_harvest_date,
            //   purchase_items: data.purchase_items.map(function (item, index) {
            //     return {
            //       ...item,
            //       index: index + 1,
            //       $hide: data.ticketable.ticket.customer_type === "brs",
            //     };
            //   }),
            //   operational_cost_document: data.files.filter((file) => file.name === 'operational cost document')?.[0],
            //   invoice_documents: data.files.filter((file) => file.name === 'invoice document'),
            //   down_payment_documents: data.files.filter((file) => file.name === 'down payment document'),
            // };

            return response;
          })
    },
    setModelFromFetchData(data) {
      this.model = {
        ...data,
        ordered_at: data.ordered_at || data.estimated_harvest_date,
        purchase_items: data.purchase_items.map(function (item, index) {
          return {
            ...item,
            index: index + 1,
            $hide: data.ticketable.ticket.customer_type === "brs",
          };
        }),
        operational_cost_document: data.files.filter((file) => file.name === 'operational cost document')?.[0],
        invoice_documents: data.files.filter((file) => file.name === 'invoice document'),
        down_payment_documents: data.files.filter((file) => file.name === 'down payment document'),
      };
    },
    fetchModelActivityLogs() {
      return this.$axios.get(`/v1/purchase_orders/${this.$route.params.key}/activity_logs`, {
        params: {
          per_page: 1000,
        },
        timeout: 30000,
      })
          .then(res => {
            // const {data: {data}} = res
            // this.$set(this, 'activity_logs', data)

            return res
          })
    },
    setActivityLogs(data) {
      this.$set(this, 'activity_logs', data)
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .preloader-component {
    background-color: #ffffff;
  }
}

.container-title {
  margin-top: 10px;
  font-family: Lato;
  font-size: 12px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.05em;
  text-align: left;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-family: 'Lato';
  color: #6C7589;
}

.custom-group {
  margin-bottom: 30px;
}

.custom-label,
.custom-text {
  font-family: Lato;
  font-size: 14px;

  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

.custom-label,
.label {
  font-weight: 700;
  color: #161b4d;
  text-transform: capitalize;
  margin-bottom: 10px;
}

.custom-text,
.value {
  font-weight: 400;
  color: #6c7589;
}

.value:not(.no-colon)::before {
  content: ": ";
}

.section-title {
  background-color: #f9fafb;
  color: #161b4d;
  padding: 14px 21px;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
  border: 1px solid #ececf2;
}

.section-title:first-of-type {
  border-top: none;
}

.section-body {
  padding: 14px 20px;

  .section-label,
  .section-value {
    font-family: Lato;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }

  .section-label {
    color: #161b4d;
    font-weight: 400;
  }

  .section-value {
    color: #161b4d;
    font-weight: 700;
    text-align: right;
  }

  .section-row {
    padding: 6px 0;
  }
}

.sale-item-thead {
  color: #161b4d;
  background-color: #f9fafb;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
}

.sale-item-tbody {
  color: #161b4d;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

::v-deep .page-content {
  background: #eef3f7;
}

$badge-background-primary: rgba(198, 239, 255, 0.3);
$badge-color-primary: #0084f3;
$badge-background-warning: #fff8e7;
$badge-color-warning: #ff9d0b;

.badge-container {
  &-base {
    background: $badge-background-primary;

    .stakeholder {
      color: #161b4d;
      font-weight: 700;
      font-size: 14px;
    }

    .name {
      font-weight: 700;
      font-size: 20px;
    }
  }

  &-primary {
    @extend .badge-container-base;

    .name {
      color: $badge-color-primary;
    }
  }

  &-warning {
    @extend .badge-container-base;
    background: $badge-background-warning;

    .name {
      color: $badge-color-warning;
    }
  }
}

ul#activity-log-list {
  li {
    ::marker {
      color: #667085 !important;
    }
  }
}

.scrollable-container {
  height: 400px;
  overflow-y: scroll;
}

.scrollable-container::-webkit-scrollbar {
  width: 8px; /* Scrollbar width */
}

.scrollable-container::-webkit-scrollbar-track {
  background: #f0f0f0; /* Track background */
  border-radius: 5px;
}

.scrollable-container::-webkit-scrollbar-thumb {
  background: #b0b0b0; /* Scrollbar thumb color */
  border-radius: 5px;
}

.scrollable-container::-webkit-scrollbar-thumb:hover {
  background: #555; /* Thumb color on hover */
}

a.activity-log-collapse {
  color: #1664D8;
  font-weight: bold;
}

::v-deep {
  .overflow-hidden {
    overflow: hidden !important;
  }

  table {
    thead {
      background: #F9FAFB !important;
    }
  }
}
</style>